import { absolutePath } from "./absolutePath";

export const emailHub = {
  onboarding: {
    check: () => absolutePath("email_hub/onboarding"),
    getPopularWorkflowTemplates: () =>
      absolutePath("email_hub/onboarding/popular_workflow_templates"),
    getRecentlyUpdated: () =>
      absolutePath("email_hub/onboarding/recently_updated_resources?limit=4"),
    updateChecklist: () => absolutePath("email_hub/onboarding"),
  },
  senderAddresses: {
    index: () => absolutePath("email_hub/sender_addresses"),
    create: () => absolutePath("email_hub/sender_addresses"),
    update: (id: number) => absolutePath(`email_hub/sender_addresses/${id}`),
    destroy: (id: number) => absolutePath(`email_hub/sender_addresses/${id}`),
    setDefault: (id: number) =>
      absolutePath(`email_hub/sender_addresses/${id}/set_default`),
  },
  builder: {
    colorPalette: {
      show: () => absolutePath("email_hub/builder/color_palette"),
      update: () => absolutePath("email_hub/builder/color_palette"),
    },
  },
  themes: {
    index: () => absolutePath("email_hub/themes"),
    show: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}`),
    create_custom_theme: () =>
      absolutePath("email_hub/themes/create_custom_theme"),
    upsert_custom_theme: () =>
      absolutePath("email_hub/themes/upsert_custom_theme"),
    update: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}`),
    replace_and_delete: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}/replace_and_delete`),
  },
};
